import React from "react";
import {Tooltip} from 'antd';
import moment from 'moment';
import  PropTypes from 'prop-types';
import {
  ExchangeFromTable,
  FooterWrapper,
  DollarAmount,
  FooterText,
  UnderlyingContent
} from "./styles";
import {
  dollarText,
  pricePerUnitText,
  replaceSelect
} from "../../../../../utils/replacer";
import CurrencyInput from "../../../../../CommonComponents/CurrencyInput/CurrencyInput";
import {
  DataValue,
  DataHeading
} from "../../../../../CommonComponents/commonStyles";

const TiffFormTable = props => {
  const investmentPoolData = [];

  function renderFooter() {
    return (
      <FooterWrapper>
        <FooterText className="left">Amount to be exchanged to TIFF: </FooterText>
        <DollarAmount className="right">
          {props.totalDollar === 0 ? "$0.00" : dollarText(props.totalDollar)}
        </DollarAmount>
      </FooterWrapper>
    );
  }
  const columns = [
    {
      title: () => {
        return <DataValue>Investment options</DataValue>;
      },
      render: record => {
        return <DataHeading>{replaceSelect(record.poolName)}</DataHeading>;
      },
      key: "poolName",
      width: "20%"
    },
    {
      title: () => {
        return <DataValue>Available balance</DataValue>;
      },
      render: record => {
        return (
          <> {
          props.isEdit ? props.cloneExchangeIntoPool ?
           (  <DataHeading>{dollarText(record.availableBalance + +props.cloneExchangeIntoPool[record.poolId])}</DataHeading>):
          (<DataHeading>{dollarText(record.availableBalance )}</DataHeading>):
          (<DataHeading>{dollarText(record.availableBalance )}</DataHeading>)
          }</>
        )
      },
      key: "availableBalance",
      width: "20%"
    },
    {
      title: () => {
        return <DataValue>Available units</DataValue>;
      },
      render: record => {
        return (
          <DataHeading>
            {Number(record.availableUnits).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </DataHeading>
        );
      },
      key: "availableUnits",
      width: "20%"
    },
    {
      title: () => {
        return <DataValue>Price per unit</DataValue>;
      },
      render: record => {
        const perUpdatedOn = 'Price updated on ' + moment(moment.tz(record.dateOfPricePerUnit, 'America/New_York')).format('MM/DD/YYYY')
        return (
          record.pricePerUnit !== null ? 
          <Tooltip placement="bottomLeft" title={perUpdatedOn}>
            <UnderlyingContent>
              {pricePerUnitText(record.pricePerUnit, record.isRise)}
            </UnderlyingContent>
          </Tooltip> : <>&mdash;</>
        );
      },
      key: "pricePerUnit",
      width: "20%"
    },
    {
      title: () => {
        return <DataValue>Dollars</DataValue>;
      },
      render: record => (
        <span>
          <CurrencyInput
            label="dollar input"
            id={`txtCurrencyInput${record.poolId}`}
            addonBefore="$"
            value={props.inputValues[record.poolId]}
            onChange={e => {
              const { value } = e.target;
              if (value <= record.availableBalance) {
                props.setInputValues({
                  key: record.poolId,
                  value
                });
              }
            }}
            onBlur={(e) => props.blurOutDollar(record.poolName, e.target.value, record.availableBalance, record.poolId)}
          />
        </span>
      ),
      key: "Dollar",
      width: "20%"
    }
  ];

  props.investmentPools &&
    props.investmentPools.map(pool => {
      if (pool.poolName !== props.tiffPoolName) {
        investmentPoolData.push(pool);
      }
      return true;
    });

  return (
    <ExchangeFromTable
      data-test="container"
      pagination={false}
      style={{ width: "100%" }}
      scroll={{ y: 500 }}
      columns={columns}
      dataSource={investmentPoolData}
      footer={() => renderFooter()}
    />
  );
};

TiffFormTable.propTypes = {
  setInputValues: PropTypes.func,
  inputValues: PropTypes.object,
  cloneExchangeIntoPool: PropTypes.object,
  isEdit: PropTypes.bool,
}

export default TiffFormTable;
